import React, { useEffect, useState } from "react";
import {
  fetchBookingById,
  fetchPaymentById,
  removePayment,
} from "../../store/slices/Booking/thunk";
import ArrowBack from "@mui/icons-material/ArrowBack";
import CheckCircle from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import FilterList from "@mui/icons-material/FilterList";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import Phone from "@mui/icons-material/Phone";
import Business from "@mui/icons-material/Business";
import Visibility from "@mui/icons-material/Visibility";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MailIcon from "@mui/icons-material/Mail";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import WhereToVoteIcon from "@mui/icons-material/WhereToVote";
import PersonIcon from "@mui/icons-material/Person";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { fetchVehicleGroup } from "../../store/slices/Vehicle/thunk";
import PassengerTable from "../../components/PassengerTable";
import "./booking.scss";

const ViewDetail = () => {
  const navigate = useNavigate();
  const [paymentModal, setPaymentmodal] = useState(false);
  const [tripModal, setTripmodal] = useState(false);
  const [customerDetails, setCustomerDetails] = useState<any>([]);
  const [driverDetails, setDriverDetails] = useState<any>({});
  const [bookingDetails, setBookingDetails] = useState<any>({});
  const dispatch: any = useDispatch();
  const { id } = useParams<any>();
  const [getAllPayment, setAllPayment] = useState([]);
  const [searchEmployee, setSearchEmployee] = useState("");

  const getStatusColor = (status: string) => {
    switch (status) {
      case "yetToStart":
        return "warning";
      case "onGoing":
        return "info";
      case "completed":
        return "success";
      case "cancelled":
        return "error";
      default:
        return "default";
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case "yetToStart":
        return "Yet to Start";
      case "onGoing":
        return "On Going";
      case "completed":
        return "Completed";
      case "cancelled":
        return "Cancelled";
      default:
        return status;
    }
  };

  const handleDataSave = async (data: any) => {
    try {
      const res: any = await dispatch(fetchPaymentById(bookingDetails._id));
      if (res?.data) {
        setAllPayment(res.data);
        const response: any = await dispatch(
          fetchBookingById(bookingDetails._id)
        );
        setBookingDetails(response?.data?.findBookingById);
      }
      setPaymentmodal(false);
    } catch (error) {
      console.error("Error fetching group list:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        const response: any = await dispatch(fetchBookingById(id));
        const bookingData = response?.data?.findBookingById;

        if (!bookingData) {
          console.error("❌ bookingData is undefined.");
          return;
        }

        setCustomerDetails(response?.data?.findCustomers);
        setDriverDetails(response?.data?.findDriver || {});
        setBookingDetails(response?.data?.findBookingById || {});
      }
    };

    const fetchPayment = async () => {
      if (id) {
        const response: any = await dispatch(fetchPaymentById(id));
        if (response && response?.data) {
          setAllPayment(response?.data);
        } else {
          setAllPayment([]);
        }
      }
    };
    fetchPayment();
    fetchData();
  }, [id, dispatch]);

  const deletePayment = async (id: string) => {
    try {
      const response: any = await dispatch(removePayment(id));
      if (response && response.isSuccess) {
        const newPayment = getAllPayment.filter((item: any) => item._id !== id);
        setAllPayment(newPayment);
        let findNewBooking = await dispatch(
          fetchBookingById(bookingDetails._id)
        );
        setBookingDetails(findNewBooking.data.findBookingById);
        toast.success("Payment deleted successfully!");
      }
    } catch (error) {
      toast.error("Failed to delete payment!");
    }
  };

  const navigateToBookingList = () => {
    navigate("/booking-list");
  };

  const handleCopyTripId = () => {
    if (bookingDetails?.tripId) {
      navigator.clipboard.writeText(bookingDetails.tripId);
      toast.success("Trip ID copied to clipboard!");
    }
  };

  const getAvatarColor = (name: string) => {
    const colors = [
      "#3B82F6", "#10B981", "#F59E0B", "#8B5CF6", "#EF4444",
      "#06B6D4", "#EC4899", "#F97316", "#84CC16", "#6366F1",
    ];
    const charCode = (name?.charCodeAt(0) || 0) + (name?.charCodeAt(1) || 0);
    return colors[charCode % colors.length];
  };

  return (
    <div style={{ padding: "20px 0px", minHeight: "100vh" }}>
      <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: "1900px", margin: "0 auto", backgroundColor: "transparent", minHeight: "100vh" }}>
        <ToastContainer />

        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: "flex", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: 2, mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <button
                onClick={navigateToBookingList}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "#3b82f6",
                  flexShrink: 0,
                }}
              >
                <ArrowBack fontSize="small" />
              </button>
              <Typography variant="h4" sx={{ fontWeight: 700, fontSize: { xs: "20px", sm: "24px" }, color: "#0f172a", fontFamily: "sans-serif" }}>
                Trip Details
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
              {bookingDetails?.tripStatus && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    backgroundColor: "#DCFCE7",
                    color: "#16A34A",
                    borderRadius: "9999px",
                    padding: "4px 12px",
                    fontSize: "13px",
                    fontWeight: 600,
                  }}
                >
                  <CheckCircle style={{ fontSize: "14px" }} />
                  {getStatusText(bookingDetails.tripStatus)}
                </span>
              )}
              {bookingDetails?.tripId && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    backgroundColor: "#F1F5F9",
                    color: "#64748b",
                    borderRadius: "9999px",
                    padding: "4px 12px",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  Trip ID: {bookingDetails.tripId}
                  <ContentCopyIcon
                    style={{ fontSize: "14px", cursor: "pointer", color: "#94a3b8" }}
                    onClick={handleCopyTripId}
                  />
                </span>
              )}
            </Box>
          </Box>
        </Box>

        {/* Main Content Grid */}
        <Grid container spacing={3}>
          {/* 3 Info Cards */}
          <Grid container spacing={2} size={{ xs: 12 }}>
            {/* Trip Route Card */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Card sx={{ height: "100%", width: "100%", borderRadius: 3, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid #F1F5F9" }}>
                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
                    <LocationOnIcon sx={{ color: "#3B82F6", fontSize: "20px" }} />
                    <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "16px", color: "#0f172a" }}>
                      Trip Route
                    </Typography>
                  </Box>

                  <Stack spacing={0}>
                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Box sx={{ width: "32px", height: "32px", borderRadius: "50%", border: "2px solid #3B82F6", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <Box sx={{ width: "10px", height: "10px", borderRadius: "50%", backgroundColor: "#3B82F6" }} />
                        </Box>
                        <Box sx={{ width: "2px", height: "36px", borderLeft: "2px dashed #CBD5E1", mt: 0.5 }} />
                      </Box>
                      <Box sx={{ flex: 1, pt: 0.5 }}>
                        <Typography sx={{ fontSize: "12px", color: "#64748b", fontWeight: 500, mb: 0.5 }}>
                          Start Location
                        </Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#0f172a", mb: 0.5, wordBreak: "break-word" }}>
                          {bookingDetails?.startLocation?.streetAddress || "--"}
                        </Typography>
                        {bookingDetails?.tripStartDate && (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mt: 0.5, flexWrap: "wrap" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              <CalendarTodayIcon fontSize="small" sx={{ color: "#94a3b8", fontSize: "14px" }} />
                              <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
                                {new Date(bookingDetails.activityBookingCreatedOn).toLocaleDateString("en-GB")}
                              </Typography>
                            </Box>
                            {bookingDetails.startTime && (
                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <AccessTimeIcon fontSize="small" sx={{ color: "#94a3b8", fontSize: "14px" }} />
                                <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
                                  {new Date(bookingDetails.startTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        )}
                      </Box>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                      <Box sx={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: "#FEE2E2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <LocationOnIcon sx={{ color: "#EF4444", fontSize: "18px" }} />
                      </Box>
                      <Box sx={{ flex: 1, pt: 0.5 }}>
                        <Typography sx={{ fontSize: "12px", color: "#64748b", fontWeight: 500, mb: 0.5 }}>
                          End Location
                        </Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#0f172a", mb: 0.5, wordBreak: "break-word" }}>
                          {bookingDetails?.endLocation?.streetAddress || "--"}
                        </Typography>
                        {bookingDetails?.tripEndDate && (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
                            <CalendarTodayIcon fontSize="small" sx={{ color: "#94a3b8", fontSize: "14px" }} />
                            <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
                              {new Date(bookingDetails.tripEndDate).toLocaleDateString("en-GB")}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            {/* Driver Card */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Card sx={{ height: "100%", width: "100%", borderRadius: 3, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid #F1F5F9" }}>
                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
                    <PersonIcon sx={{ color: "#3B82F6", fontSize: "20px" }} />
                    <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "16px", color: "#0f172a" }}>
                      Driver Information
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
                    <Box sx={{ position: "relative", flexShrink: 0 }}>
                      <Avatar
                        src={driverDetails?.driverImage}
                        sx={{ width: 64, height: 64, border: "2px solid #E2E8F0" }}
                      >
                        {driverDetails?.driverName?.charAt(0) || "D"}
                      </Avatar>
                      <Box sx={{ position: "absolute", bottom: 0, right: 0, width: "16px", height: "16px", borderRadius: "50%", backgroundColor: "#22C55E", border: "2px solid #ffffff" }} />
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: "16px", color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {driverDetails?.driverName || "--"}
                      </Typography>
                      <Typography sx={{ fontSize: "13px", color: "#64748b" }}>
                        Professional Driver
                      </Typography>
                    </Box>
                  </Box>

                  <Stack spacing={2}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1.5, backgroundColor: "#F8FAFC", borderRadius: "10px" }}>
                      <Phone sx={{ color: "#3B82F6", fontSize: "18px", flexShrink: 0 }} />
                      <Typography sx={{ fontSize: "14px", color: "#0f172a", fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {driverDetails?.phoneNumber || "--"}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1.5, backgroundColor: "#F8FAFC", borderRadius: "10px" }}>
                      <MailIcon sx={{ color: "#3B82F6", fontSize: "18px", flexShrink: 0 }} />
                      <Typography sx={{ fontSize: "14px", color: "#0f172a", fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {driverDetails?.email || "--"}
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            {/* Vehicle Card */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Card sx={{ height: "100%", width: "100%", borderRadius: 3, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid #F1F5F9" }}>
                <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
                    <DirectionsCarIcon sx={{ color: "#3B82F6", fontSize: "20px" }} />
                    <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "16px", color: "#0f172a" }}>
                      Vehicle Information
                    </Typography>
                  </Box>

                  <Stack spacing={3}>
                    {[
                      { label: "Vehicle Name", value: bookingDetails?.vehicle?.vehicleName },
                      { label: "Registration Number", value: bookingDetails?.vehicle?.registrationNumber },
                      { label: "Engine Number", value: bookingDetails?.vehicle?.engineNo },
                    ].map((item, idx) => (
                      <Box key={idx} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography sx={{ fontSize: "12px", color: "#64748b", mb: 0.5 }}>
                            {item.label}
                          </Typography>
                          <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {item.value || "--"}
                          </Typography>
                        </Box>
                        <ContentCopyIcon
                          fontSize="small"
                          sx={{ color: "#94a3b8", cursor: "pointer", fontSize: "16px", flexShrink: 0 }}
                          onClick={() => {
                            if (item.value) {
                              navigator.clipboard.writeText(item.value);
                              toast.success(`${item.label} copied!`);
                            }
                          }}
                        />
                      </Box>
                    ))}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Employees Table */}
          <Grid size={{ xs: 12 }}>
            <Card sx={{ borderRadius: 3, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid #F1F5F9" }}>
              <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                {/* Table Header */}
                <Box sx={{ display: "flex", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, justifyContent: "space-between", gap: 2, mb: 3 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <PersonIcon sx={{ color: "#3B82F6", fontSize: "20px" }} />
                    <Typography sx={{ fontWeight: 700, fontSize: "16px", color: "#0f172a" }}>
                      Employees ({customerDetails?.length || 0})
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, width: { xs: "100%", sm: "auto" } }}>
                    <Box sx={{ position: "relative", width: { xs: "100%", sm: "260px" } }}>
                      <SearchIcon sx={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#9CA3AF", fontSize: "18px" }} />
                      <input
                        type="text"
                        placeholder="Search employee..."
                        value={searchEmployee}
                        onChange={(e) => setSearchEmployee(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px 8px 36px",
                          borderRadius: "8px",
                          border: "1px solid #E5E7EB",
                          outline: "none",
                          fontSize: "14px",
                          color: "#374151",
                          backgroundColor: "#ffffff",
                        }}
                      />
                    </Box>
                    <button style={{ width: "36px", height: "36px", borderRadius: "8px", border: "1px solid #E5E7EB", backgroundColor: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#6B7280", flexShrink: 0 }}>
                      <FilterList style={{ fontSize: "18px" }} />
                    </button>
                  </Box>
                </Box>

                {/* Table - Responsive */}
                <Box className="responsive-table-wrapper" sx={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px" }}>
                    <thead>
                      <tr style={{ backgroundColor: "#F9FAFB" }}>
                        {["#", "Employee", "Contact", "Designation", "Action"].map((h) => (
                          <th key={h} style={{ textAlign: h === "Action" ? "right" : "left", padding: "12px 16px", fontSize: "12px", fontWeight: 600, color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid #E5E7EB" }}>
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const filtered = (customerDetails || []).filter((c: any) => {
                          const term = searchEmployee.toLowerCase();
                          return (
                            !term ||
                            (c.name || c.customerName || "").toLowerCase().includes(term) ||
                            (c.mobile || "").toLowerCase().includes(term) ||
                            (c.pickupLocation?.streetAddress || "").toLowerCase().includes(term)
                          );
                        });
                        if (filtered.length === 0) {
                          return (
                            <tr>
                              <td colSpan={5} style={{ textAlign: "center", padding: "40px", color: "#6B7280", fontSize: "14px" }}>
                                No employees found.
                              </td>
                            </tr>
                          );
                        }
                        return filtered.map((customer: any, index: number) => (
                          <tr key={customer.customerId || index} style={{ borderBottom: "1px solid #F3F4F6" }}>
                            <td style={{ padding: "14px 16px", fontSize: "14px", fontWeight: 500, color: "#374151" }}>
                              {index + 1}
                            </td>
                            <td style={{ padding: "14px 16px" }}>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <Box sx={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: getAvatarColor(customer.name || customer.customerName || ""), display: "flex", alignItems: "center", justifyContent: "center", color: "#ffffff", fontWeight: 600, fontSize: "13px", flexShrink: 0 }}>
                                  {(customer.name || customer.customerName || "U").charAt(0).toUpperCase()}
                                </Box>
                                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {customer.name || customer.customerName || "--"}
                                </Typography>
                              </Box>
                            </td>
                            <td style={{ padding: "14px 16px" }}>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Phone sx={{ color: "#3B82F6", fontSize: "14px", flexShrink: 0 }} />
                                <Typography sx={{ fontSize: "14px", color: "#4B5563", whiteSpace: "nowrap" }}>
                                  {customer.mobile || "--"}
                                </Typography>
                              </Box>
                            </td>
                            <td style={{ padding: "14px 16px" }}>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <LocationOnIcon sx={{ color: "#9CA3AF", fontSize: "14px", flexShrink: 0 }} />
                                <Typography sx={{ fontSize: "14px", color: "#4B5563", maxWidth: { xs: "120px", sm: "280px" }, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {customer.pickupLocation?.streetAddress || customer.customerPickupLocation?.streetAddress || "--"}
                                </Typography>
                              </Box>
                            </td>
                            <td style={{ padding: "14px 16px", textAlign: "right" }}>
                              <Box sx={{ display: "flex", alignItems: "center", justifyContent: { xs: "flex-start", sm: "flex-end" }, gap: 1, flexWrap: "wrap" }}>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", backgroundColor: "#DCFCE7", color: "#16A34A", borderRadius: "6px", padding: "4px 10px", fontSize: "12px", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}>
                                  <Visibility style={{ fontSize: "14px" }} />
                                  View
                                </span>
                                <a href={`tel:${customer.mobile}`} style={{ display: "inline-flex", alignItems: "center", gap: "4px", backgroundColor: "#EFF6FF", color: "#2563EB", borderRadius: "6px", padding: "4px 10px", fontSize: "12px", fontWeight: 600, textDecoration: "none", whiteSpace: "nowrap" }}>
                                  <Phone style={{ fontSize: "14px" }} />
                                  Phone
                                </a>
                                <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", backgroundColor: "#F3E8FF", color: "#9333EA", borderRadius: "6px", padding: "4px 10px", fontSize: "12px", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" }}>
                                  <Business style={{ fontSize: "14px" }} />
                                  Company
                                </span>
                                <button style={{ width: "28px", height: "28px", borderRadius: "6px", border: "1px solid #E5E7EB", backgroundColor: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#6B7280" }}>
                                  <MoreHoriz style={{ fontSize: "16px" }} />
                                </button>
                              </Box>
                            </td>
                          </tr>
                        ));
                      })()}
                    </tbody>
                  </table>
                </Box>

                {/* Pagination Footer */}
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 2, pt: 2, borderTop: "1px solid #F3F4F6", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
                  <Typography sx={{ fontSize: "14px", color: "#6B7280" }}>
                    Showing <span style={{ fontWeight: 500, color: "#374151" }}>1</span> to <span style={{ fontWeight: 500, color: "#374151" }}>{(customerDetails || []).length}</span> of <span style={{ fontWeight: 500, color: "#374151" }}>{(customerDetails || []).length}</span> entries
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <button style={{ width: "32px", height: "32px", borderRadius: "8px", border: "1px solid #E5E7EB", backgroundColor: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#9CA3AF" }}>
                      <ChevronLeft style={{ fontSize: "18px" }} />
                    </button>
                    <button style={{ width: "32px", height: "32px", borderRadius: "8px", border: "none", backgroundColor: "#2563EB", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#ffffff", fontSize: "14px", fontWeight: 600 }}>
                      1
                    </button>
                    <button style={{ width: "32px", height: "32px", borderRadius: "8px", border: "1px solid #E5E7EB", backgroundColor: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#9CA3AF" }}>
                      <ChevronRight style={{ fontSize: "18px" }} />
                    </button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Trip Video */}
          <Grid size={{ xs: 12 }}>
            <Card sx={{ borderRadius: 3, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid #F1F5F9" }}>
              <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, fontSize: "16px", color: "#0f172a" }}>
                  Trip Video
                </Typography>

                {bookingDetails?.videoUrl ? (
                  <Box
                    component="video"
                    controls
                    src={bookingDetails.videoUrl}
                    sx={{
                      width: "100%",
                      maxHeight: { xs: 250, sm: 420 },
                      borderRadius: 2,
                      bgcolor: "common.black",
                    }}
                  />
                ) : (
                  <Typography variant="body2" color="text.secondary" sx={{ py: 4, textAlign: "center" }}>
                    Video not available
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default ViewDetail;
